function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.23 2.524a4.997 4.997 0 00-6.663 2.17 3.996 3.996 0 00-2.351 6.843l9.014-9.013zM4.667 12.667h8A3.335 3.335 0 0016 9.333a3.317 3.317 0 00-3.1-3.306 4.983 4.983 0 00-.398-1.196l-7.835 7.836z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.988 3.215L3.27 15.934l-1.212-1.211 12.72-12.72 1.21 1.212z",
  fill: "currentColor"
})));